import _ from 'lodash';
import React from 'react';

import CountryFlag from '../common/CountryFlag';
export function LocalesList({ locales }) {
  return <span>{_.map(locales, s => <CountryFlag countryCode={s.replace('en', 'us').replace('pt', 'br')}
                                                 key={s}/>)}</span>;
}
